var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { defaultProps } from './defaults';
import Tooltip from '../Tooltip';
import Overlay from './overlay';
var Popconfirm = /** @class */ (function (_super) {
    __extends(Popconfirm, _super);
    function Popconfirm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            visible: false,
        };
        return _this;
    }
    Popconfirm.prototype.closeTooltip = function () {
        if (!this.props.async) {
            this.setState({ visible: false });
        }
    };
    Popconfirm.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, _b = _a.triggerEvent, triggerEvent = _b === void 0 ? 'click' : _b, okText = _a.okText, cancelText = _a.cancelText, title = _a.title, overlayClassName = _a.overlayClassName, icon = _a.icon, onConfirm = _a.onConfirm, onCancel = _a.onCancel, async = _a.async, visible = _a.visible, placement = _a.placement, disabled = _a.disabled, backgroundColor = _a.backgroundColor, defaultVisible = _a.defaultVisible;
        var over = (React.createElement(Overlay, { okText: okText, cancelText: cancelText, title: title, icon: icon, onConfirm: function () {
                _this.closeTooltip();
                onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
            }, onCancel: function () {
                _this.closeTooltip();
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            } }));
        return (React.createElement(Tooltip, { title: over, placement: placement, trigger: triggerEvent, visible: async ? visible : this.state.visible, showLabel: disabled, backgroundColor: backgroundColor, className: (overlayClassName ? overlayClassName : '') + " legao-popconfirm", defaultVisible: defaultVisible }, children));
    };
    Popconfirm.NAME = 'popconfirm';
    Popconfirm.defaultProps = defaultProps;
    return Popconfirm;
}(React.Component));
export { Popconfirm };
